import { render, staticRenderFns } from "./PrintCertificate.vue?vue&type=template&id=14d220d3"
import script from "./PrintCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintCertificate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrintCertificate.vue?vue&type=style&index=0&id=14d220d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports